module.exports = __webpack_public_path__ + "media/images/favicon-bed1dde5.ico";